<div
    [hidden]="!showSkeleton"
    (deferLoad)="inScreen.emit()"
    class="skeleton"
    [ngStyle]="{
        'aspect-ratio': skeletonStyles?.aspectRatio,
        'border-radius': skeletonStyles?.borderRadius,
        'width': skeletonStyles?.width ?? 'auto',
        'height': skeletonStyles?.height ?? 'auto'
    }"
></div>
